import React, { useState, useEffect } from "react";
import axios from "axios";
import { BaseUrl } from "../App";
import { Circles } from 'react-loader-spinner';
import { FadeLoader } from 'react-spinners';


const SmsNoti = () => {
  // const [loading, setLoading] = useState(true);
  const [methods, setMethods] = useState([
    {
      name: "Twilio SMS Gateway",
      fname: "Twilio Account Settings",
      fields: [
        {
          label: "Account SID",
          type: "text",
          name: "ct_sms_twilio_account_SID",
          value: "",
        },
        {
          label: "Auth Token",
          type: "text",
          name: "ct_sms_twilio_auth_token",
          value: "",
        },
        {
          label: "Twilio Sender Number",
          type: "text",
          name: "ct_sms_twilio_sender_number",
          value: "",
        },
        {
          label: "Admin Phone Number",
          type: "number",
          name: "ct_sms_twilio_admin_phone_number",
          value: "",
        },
      ],
      tname: "Twilio SMS Settings",
      toggles: [
        {
          label: "Send SMS To Client",
          name: "ct_sms_twilio_send_sms_to_client_status",
          enabled: false,
        },
        {
          label: "Send SMS To Admin",
          name: "ct_sms_twilio_send_sms_to_admin_status",
          enabled: false,
        },
        {
          label: "Send SMS To Staff",
          name: "ct_sms_twilio_send_sms_to_staff_status",
          enabled: false,
        },
      ],
      enabled: false,
      statusName: "ct_sms_twilio_status",
    },
    {
      name: "Plivo SMS Gateway",
      fname: "Plivo Account Settings",
      fields: [
        {
          label: "Account SID",
          type: "text",
          name: "ct_sms_plivo_account_SID",
          value: "",
        },
        {
          label: "Auth Token",
          type: "text",
          name: "ct_sms_plivo_auth_token",
          value: "",
        },
        {
          label: "Plivo Sender Number",
          type: "text",
          name: "ct_sms_plivo_sender_number",
          value: "",
        },
        {
          label: "Admin Phone Number",
          type: "number",
          name: "ct_sms_plivo_admin_phone_number",
          value: "",
        },
      ],
      tname: "Plivo SMS Settings",
      toggles: [
        {
          label: "Send SMS To Client",
          name: "ct_sms_plivo_send_sms_to_client_status",
          enabled: false,
        },
        {
          label: "Send SMS To Admin",
          name: "ct_sms_plivo_send_sms_to_admin_status",
          enabled: false,
        },
        {
          label: "Send SMS To Staff",
          name: "ct_sms_plivo_send_sms_to_staff_status",
          enabled: false,
        },
      ],
      enabled: false,
      statusName: "ct_sms_plivo_status",
    },
    {
      name: "Nexmo SMS Gateway",
      fname: "Nexmo SMS Settings",
      fields: [
        {
          label: "Nexmo API Key",
          type: "text",
          name: "ct_nexmo_api_key",
          value: "",
        },
        {
          label: "Nexmo API Secret",
          type: "text",
          name: "ct_nexmo_api_secret",
          value: "",
        },
        { label: "Nexmo From", type: "text", name: "ct_nexmo_from", value: "" },
        {
          label: "Admin Phone Number",
          type: "number",
          name: "ct_sms_nexmo_admin_phone_number",
          value: "",
        },
      ],
      tname: " ",
      toggles: [
        { label: "Nexmo Status", name: "ct_nexmo_status", enabled: false },
        {
          label: "Nexmo Send Sms To Client Status",
          name: "ct_sms_nexmo_send_sms_to_client_status",
          enabled: false,
        },
        {
          label: "Nexmo Send Sms To admin Status",
          name: "ct_sms_nexmo_send_sms_to_admin_status",
          enabled: false,
        },
        {
          label: "Send SMS To Staff",
          name: "ct_sms_nexmo_send_sms_to_staff_status",
          enabled: false,
        },
      ],
      enabled: false,
      statusName: "ct_sms_nexmo_status",
    },
    {
      name: "Textlocal SMS Gateway",
      fname: "Textlocal Account Settings",
      fields: [
        {
          label: "Account Username",
          type: "text",
          name: "ct_sms_textlocal_account_username",
          value: "",
        },
        {
          label: "Account Hash ID",
          type: "password",
          name: "ct_sms_textlocal_account_hash_id",
          value: "",
        },
        {
          label: "Admin Phone Number",
          type: "number",
          name: "ct_sms_textlocal_admin_phone",
          value: "",
        },
      ],
      tname: "Textlocal SMS Settings",
      toggles: [
        {
          label: "Send SMS To Client",
          name: "ct_sms_textlocal_send_sms_to_client_status",
          enabled: false,
        },
        {
          label: "Send SMS To Admin",
          name: "ct_sms_textlocal_send_sms_to_admin_status",
          enabled: false,
        },
        {
          label: "Send SMS To Staff",
          name: "ct_sms_textlocal_send_sms_to_staff_status",
          enabled: false,
        },
      ],
      enabled: false,
      statusName: "ct_sms_textlocal_status",
    },
    {
      name: "Messagebird SMS Gateway",
      fname: "Messagebird Account Settings",
      fields: [
        {
          label: "API Key",
          type: "text",
          name: "ct_sms_messagebird_account_apikey",
          value: "",
        },
        {
          label: "Admin Phone Number",
          type: "number",
          name: "ct_sms_messagebird_admin_phone",
          value: "",
        },
      ],
      tname: "Messagebird SMS Settings",
      toggles: [
        {
          label: "Send SMS To Client",
          name: "ct_sms_messagebird_send_sms_to_client_status",
          enabled: false,
        },
        {
          label: "Send SMS To Admin",
          name: "ct_sms_messagebird_send_sms_to_admin_status",
          enabled: false,
        },
        {
          label: "Send SMS To Staff",
          name: "ct_sms_messagebird_send_sms_to_staff_status",
          enabled: false,
        },
      ],
      enabled: false,
      statusName: "ct_sms_messagebird_status",
    },
  ]);

  const [loading, setLoading] = useState(false);
  const [changedSettings, setChangedSettings] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    let timer;
    if (error) {
      timer = setTimeout(() => {
        setError("");
      }, 5000); // 5 seconds
    }
    return () => clearTimeout(timer);
  }, [error]);
  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const response = await axios.post(`${BaseUrl}/backend/api/settings.php`, {
        action: "get_all_settings",
        api_key: "1",
      });

      if (response.data.status === "true" && response.data.statuscode === 200) {
        updateMethodsWithFetchedData(response.data.response);
      } else {
        console.error("Failed to fetch settings:", response.data.response);
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    } finally {
      setLoading(false);
    }
  };

  const updateMethodsWithFetchedData = (fetchedSettings) => {
    setMethods((prevMethods) =>
      prevMethods.map((method) => {
        const updatedMethod = { ...method };
        updatedMethod.enabled =
          fetchedSettings.find(
            (setting) => setting.option_name === method.statusName
          )?.option_value === "Y";

        updatedMethod.fields = updatedMethod.fields.map((field) => ({
          ...field,
          value:
            fetchedSettings.find(
              (setting) => setting.option_name === field.name
            )?.option_value || "",
        }));

        updatedMethod.toggles = updatedMethod.toggles.map((toggle) => ({
          ...toggle,
          enabled:
            fetchedSettings.find(
              (setting) => setting.option_name === toggle.name
            )?.option_value === "Y",
        }));

        return updatedMethod;
      })
    );
  };

  const toggleMethod = (index) => {
    setMethods((prev) =>
      prev.map((method, i) =>
        i === index ? { ...method, enabled: !method.enabled } : method
      )
    );
    setChangedSettings((prev) => ({
      ...prev,
      [methods[index].statusName]: !methods[index].enabled ? "Y" : "N",
    }));
  };

  const toggleOption = (methodIndex, toggleIndex) => {
    setMethods((prev) =>
      prev.map((method, i) =>
        i === methodIndex
          ? {
              ...method,
              toggles: method.toggles.map((toggle, j) =>
                j === toggleIndex
                  ? { ...toggle, enabled: !toggle.enabled }
                  : toggle
              ),
            }
          : method
      )
    );
    const toggleName = methods[methodIndex].toggles[toggleIndex].name;
    setChangedSettings((prev) => ({
      ...prev,
      [toggleName]: !methods[methodIndex].toggles[toggleIndex].enabled
        ? "Y"
        : "N",
    }));
  };

  const handleInputChange = (methodIndex, fieldIndex, value) => {
    setMethods((prev) =>
      prev.map((method, i) =>
        i === methodIndex
          ? {
              ...method,
              fields: method.fields.map((field, j) =>
                j === fieldIndex ? { ...field, value } : field
              ),
            }
          : method
      )
    );
    const fieldName = methods[methodIndex].fields[fieldIndex].name;
    setChangedSettings((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const saveSettings = async () => {
    try {
      setLoading(true);
      const updatePromises = Object.entries(changedSettings).map(
        ([option_name, option_value]) =>
          axios.post(`${BaseUrl}/backend/api/settings.php`, {
            action: "update_setting",
            api_key: "1",
            option_name,
            option_value,
          })
      );

      const results = await Promise.all(updatePromises);
      const allSuccessful = results.every(
        (response) =>
          response.data.status === "true" && response.data.statuscode === 200
      );

      if (allSuccessful) {
        setSuccessMessage("All settings saved successfully");
        console.log("All settings saved successfully");
        setChangedSettings({});
        // Optionally, you can show a success message to the user here
      } else {
        console.error("Failed to save some settings");
        // Optionally, you can show an error message to the user here
      }
    } catch (error) {
      console.error("Error saving settings:", error);
      // Optionally, you can show an error message to the user here
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen">
    {/* Loading Indicator */}
      {loading && (
           <div className="fixed inset-0 flex items-center justify-center z-50">
             <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
               <FadeLoader 
                 height={15}
                 width={5}
                 color="#ffffff"
                 ariaLabel="loading"
               />
               <h1 className="mt-1 text-lg text-white">Please wait...</h1>
             </div>
           </div>
         )}
         
    <div className="mx-auto p-6 bg-white shadow-md rounded-md xl:px-72">
           {successMessage && (
        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">{successMessage}</span>
        </div>
      )}

      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">{error}</span>
        </div>
      )}
        <div className="flex justify-between items-center mb-5">
      <h1 className="text-lg font-semibold mb-6">SMS Notification</h1>
      <button
          onClick={saveSettings}
          disabled={loading || Object.keys(changedSettings).length === 0}
          className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-md font-semibold transition-all duration-300 ease-in-out transform active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? "Saving..." : "Save Settings"}
        </button>
        </div>

      {loading && <div className="text-center">Loading...</div>}

      <div className="space-y-6">
        {methods.map((method, methodIndex) => (
          <div
            key={methodIndex}
            className="border bg-white-100 rounded-md p-4 shadow-sm transition-all duration-300 ease-in-out"
          >
            <div className="flex justify-between items-center">
              <h2 className="font-medium text-lg">{method.name}</h2>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={method.enabled}
                  onChange={() => toggleMethod(methodIndex)}
                />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer dark:bg-gray-700 peer-checked:bg-green-500 relative">
                  <span
                    className={`absolute w-4 h-4 bg-white rounded-full top-1 left-1 transition-transform ${
                      method.enabled ? "translate-x-5" : ""
                    }`}
                  ></span>
                </div>
              </label>
            </div>

            <div
              className={`overflow-hidden transition-all mt-10 duration-1000 ease-in-out`}
              style={{
                height: method.enabled ? "auto" : "0",
                opacity: method.enabled ? "1" : "0",
                paddingTop: method.enabled ? "10px" : "0",
                paddingBottom: method.enabled ? "10px" : "0",
              }}
            >
              <label className="text-lg font-medium">{method.fname}</label>

              {method.enabled &&
                method.fields &&
                method.fields.map((field, fieldIndex) => (
                  <div key={fieldIndex}>
                    <label className="block text-sm font-medium text-gray-700">
                      {field.label}
                    </label>
                    <input
                      type={field.type}
                      value={field.value}
                      onChange={(e) =>
                        handleInputChange(
                          methodIndex,
                          fieldIndex,
                          e.target.value
                        )
                      }
                      className="w-full mt-1 border rounded px-3 py-2"
                    />
                  </div>
                ))}

              {method.enabled && method.toggles.length > 0 && (
                <div className="mt-4 space-y-4">
                  <label className="text-lg font-medium">{method.tname}</label>
                  {method.toggles.map((toggle, toggleIndex) => (
                    <div
                      key={toggleIndex}
                      className="flex items-center justify-between mt-2 transition-all duration-300 ease-in-out"
                    >
                      <span>{toggle.label}</span>
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          className="sr-only peer"
                          checked={toggle.enabled}
                          onChange={() =>
                            toggleOption(methodIndex, toggleIndex)
                          }
                        />
                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer dark:bg-gray-700 peer-checked:bg-green-500 relative">
                          <span
                            className={`absolute w-4 h-4 bg-white rounded-full top-1 left-1 transition-transform ${
                              toggle.enabled ? "translate-x-5" : ""
                            }`}
                          ></span>
                        </div>
                      </label>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 text-right">
        <button
          onClick={saveSettings}
          disabled={loading || Object.keys(changedSettings).length === 0}
          className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-md font-semibold transition-all duration-300 ease-in-out transform active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? "Saving..." : "Save Settings"}
        </button>
      </div>
    </div>
   
  </div>
  );
};

export default SmsNoti;
